import { render } from "./UpdatePassword.vue?vue&type=template&id=d30c1782&scoped=true&ts=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"

import "./UpdatePassword.vue?vue&type=style&index=0&id=d30c1782&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d30c1782"]])

export default __exports__